import { render } from "./RulesTab.vue?vue&type=template&id=1bbf3adc&scoped=true"
import script from "./RulesTab.vue?vue&type=script&lang=js"
export * from "./RulesTab.vue?vue&type=script&lang=js"

import "./RulesTab.vue?vue&type=style&index=0&id=1bbf3adc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1bbf3adc"

export default script